import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useCreateOrUpdatePoll = () => {
  const createOrUpdatePoll = useCallback((pollPayload) => {
    const { id } = pollPayload;

    const requestParams = {
      method: id ? "PUT" : "POST",
      body: JSON.stringify(pollPayload),
      headers: { "Content-Type": "application/json" },
    };

    const url = `${MONOLITH_ORIGIN}/api/v3/activity/${id ? `${id}/` : ""}`;
    return new Request(url, requestParams);
  }, []);
  return useRestMutation(createOrUpdatePoll);
};

export default useCreateOrUpdatePoll;
